import * as styles from './styles';
import FocusableBackButton from '@components/FocusableBackButton';
import { usePatientResidentRegistrationNumberContext } from '@context/PatientResidentRegistrationNumber';

const Content = () => {
  const { goBack } = usePatientResidentRegistrationNumberContext();

  return (
    <div css={styles.content}>
      <div css={styles.titleContainer}>
        <FocusableBackButton onEnterPress={goBack} />
        <p css={styles.title}>
          건강보험 적용을 위해 <br /> 주민번호를 입력해주세요.
        </p>
      </div>
    </div>
  );
};

export default Content;
